import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import { StyledTextArea } from '../../../../Components/Generics.styled';
import { StyledButton } from '../../../../Components/Generics.styled';
const OtherProductsContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const NavButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const Btn = styled(StyledButton)`
    width: 100%;
    max-width: 360px;
    border: 1px solid white;
`;

const OtherProducts = ({
    handleNavButtonBack,
    handleNavButtonNext,
    teachDavieData,
    setTeachDavieData,
}) => {
    const { otherProducts } = { ...teachDavieData };
    const [value, setValue] = useState('');

    useEffect(() => {
        if (otherProducts !== '') {
            setValue(otherProducts);
        }
    }, [otherProducts]);

    const handleNext = () => {
        setTeachDavieData((prev) => ({ ...prev, otherProducts: value }));
        handleNavButtonNext();
    };
    return (
        <OtherProductsContainer>
            <StyledTextArea
                label="What other products or services do you sell?"
                value={value}
                onChange={(e) => {
                    setValue(e.target.value);
                }}
                placeholder="Separate each product with a comma"
            />
            <br />
            <NavButtonContainer>
                <Btn onClick={() => handleNavButtonBack()}>Previous</Btn>
                <Btn onClick={() => handleNext()}>Next</Btn>
            </NavButtonContainer>
        </OtherProductsContainer>
    );
};

OtherProducts.propTypes = {
    handleNavButtonBack: propTypes.func,
    handleNavButtonNext: propTypes.func,
    teachDavieData: propTypes.shape({}),
    setTeachDavieData: propTypes.func,
};

OtherProducts.defaultProps = {
    handleNavButtonBack: () => {},
    handleNavButtonNext: () => {},
    teachDavieData: {},
    setTeachDavieData: () => {},
};

export default OtherProducts;
